export interface StoreStatus {
  isOpen: boolean;
  nextChange: Date | null;
  currentDayHours: string | null;
}

const DAYS_MAP: { [key: string]: number } = {
  'lundi': 1,
  'mardi': 2,
  'mercredi': 3,
  'jeudi': 4,
  'vendredi': 5,
  'samedi': 6,
  'dimanche': 0,
};

function parseHourLine(line: string): { dayIndex: number; hours: string } | null {
  const normalizedLine = line.toLowerCase().trim();
  
  for (const [dayName, dayIndex] of Object.entries(DAYS_MAP)) {
    if (normalizedLine.startsWith(dayName)) {
      const parts = line.split(':');
      if (parts.length >= 2) {
        const hours = parts.slice(1).join(':').trim();
        return { dayIndex, hours };
      }
    }
  }
  
  return null;
}

function parseTimeRange(timeStr: string): [number, number] | null {
  const match = timeStr.match(/(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})/);
  if (!match) return null;
  
  const startHour = parseInt(match[1], 10);
  const startMin = parseInt(match[2], 10);
  const endHour = parseInt(match[3], 10);
  const endMin = parseInt(match[4], 10);
  
  const startMinutes = startHour * 60 + startMin;
  const endMinutes = endHour * 60 + endMin;
  
  return [startMinutes, endMinutes];
}
export function getStoreStatus(openingHoursStr: string): StoreStatus {
  if (!openingHoursStr) {
    return { isOpen: false, nextChange: null, currentDayHours: null };
  }

  const now = new Date();
  const currentDay = now.getDay();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  const lines = openingHoursStr.split(/[,\n]+/).filter(l => l.trim());
  const schedule: { [dayIndex: number]: string } = {};

  for (const line of lines) {
    const parsed = parseHourLine(line);
    if (parsed) {
      schedule[parsed.dayIndex] = parsed.hours;
    }
  }

  const todayHours = schedule[currentDay];
  
  if (!todayHours) {
    return { isOpen: false, nextChange: null, currentDayHours: null };
  }

  if (todayHours.toLowerCase().includes('fermé')) {
    return { isOpen: false, nextChange: null, currentDayHours: todayHours };
  }

  const timeRange = parseTimeRange(todayHours);
  
  if (!timeRange) {
    return { isOpen: false, nextChange: null, currentDayHours: todayHours };
  }

  const [openMinutes, closeMinutes] = timeRange;
  const isOpen = currentMinutes >= openMinutes && currentMinutes < closeMinutes;

  let nextChange: Date | null = null;
  if (isOpen) {
    nextChange = new Date(now);
    nextChange.setHours(Math.floor(closeMinutes / 60), closeMinutes % 60, 0, 0);
  } else if (currentMinutes < openMinutes) {
    nextChange = new Date(now);
    nextChange.setHours(Math.floor(openMinutes / 60), openMinutes % 60, 0, 0);
  }

  return { isOpen, nextChange, currentDayHours: todayHours };
}
